import styled from '@emotion/styled';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Button, Divider, FormControl, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';
import { gerarUrlCapa } from '../../noticia/create/gerarUrlCapa';
import { LicitacaoAnexo } from '../types/LicitacaoAnexo';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import { PublicacaoOficialAnexo } from '../../publicacaoOficial/types/PublicacaoOficialAnexo';
import { NoticiaAnexo } from '../../../../../typesSite/noticia/NoticiaAnexo';
import { OuvidoriaAnexo } from '../../ouvidoria/types/OuvidoriaAnexo';
import { AcessoInformacaoAnexo } from '../../acessoInformacao/types/AcessoInformacaoAnexo';
import { CentroApoioAnexo } from '../../centroApoio/types/CentroApoioAnexo';

interface Props {
  arquivosSalvos: LicitacaoAnexo[] | PublicacaoOficialAnexo[] | NoticiaAnexo[] | OuvidoriaAnexo[] | AcessoInformacaoAnexo[] | CentroApoioAnexo[] | null;
  arquivosParaSalvar: File[] | null;
  onFileChange: (files: File[]) => void;
  onDeleteSalvo?: (id: string) => void;
  onDeleteParaSalvar: (index: number) => void;
  onDeleteAll: () => void;
  tipo: string;
  multiple?: boolean;
}

export default function GeralAnexosUpload({ arquivosSalvos, arquivosParaSalvar, onFileChange, onDeleteSalvo, onDeleteParaSalvar, onDeleteAll, tipo, multiple = true }: Props) {
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
  });

  return (
    <Box>
      <FormControl fullWidth>
        <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />} sx={{ textTransform: 'none' }}>
          Selecione - {`${arquivosParaSalvar?.length}: Selecionado(s)`}
          <VisuallyHiddenInput
            type="file"
            onChange={e => {
              const files = e.target.files;
              if (files && files.length > 0) {
                onFileChange(Array.from(files));
              }
            }}
            multiple={multiple == null ? true : multiple}
            accept="image/*,.pdf"
          />
        </Button>
      </FormControl>

      {arquivosSalvos?.map((file, i) =>
        !file.excluido ? (
          <Box key={i} display="flex" flexDirection="column" gap={1} mt={2} p={2} border="1px solid #ddd" borderRadius={1}>
            {file.tipo.toUpperCase().includes('IMAGE') ? (
              <>
                <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Box>
                    <img src={gerarUrlCapa(file.path, tipo)} alt="Miniatura" style={{ maxWidth: '100%', maxHeight: '150px' }} />
                    <Typography variant="body2">{file.nomeOriginal}</Typography>
                  </Box>
                  <Box>
                    <DownloadAnexoButton tipo={tipo} ida={file.path} fileName={file.nomeOriginal} />
                    <Button color="error" onClick={() => onDeleteSalvo?.(file.id)}>
                      <GridDeleteIcon color="error" />
                    </Button>
                  </Box>
                </Box>
              </>
            ) : (
              <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" color="secondary">
                    {file.nomeOriginal}
                  </Typography>
                </Box>
                <Box>
                  <DownloadAnexoButton tipo={tipo} ida={file.path} fileName={file.nomeOriginal} />
                  <Button color="error" onClick={() => onDeleteSalvo?.(file.id)}>
                    <GridDeleteIcon color="error" />
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        ) : null
      )}

      {arquivosParaSalvar && arquivosParaSalvar.length > 0 && (
        <List dense>
          {arquivosParaSalvar.map((file, index) => (
            <ListItem key={index}>
              <ListItemText primary={file.name} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => onDeleteParaSalvar(index)}>
                  <GridDeleteIcon color="secondary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
          <Divider component="li" />

          {arquivosParaSalvar?.length > 0 && (
            <Box display="flex" justifyContent="flex-end">
              <Button onClick={onDeleteAll} color="error" sx={{ mt: 2 }}>
                Excluir todos
              </Button>
            </Box>
          )}
        </List>
      )}
    </Box>
  );
}
